export type WorkTypeLevel = 1 | 2 | 3 | 4

export const WORK_TYPE_LEVELS: WorkTypeLevel[] = [1, 2, 3, 4]

export interface WorkTypeLevelMeta {
  level: WorkTypeLevel
  title: string
  shortLabel: string
  filterLabel: string
  description: string
  color: string
}

export const WORK_TYPE_LEVEL_META: Record<WorkTypeLevel, WorkTypeLevelMeta> = {
  1: {
    level: 1,
    title: 'Bespoke work',
    shortLabel: '1 - Bespoke',
    filterLabel: '1 - Bespoke',
    description:
      'Bespoke work. Custom engineering that doesn’t fit a productised path yet.',
    color: '#b45309',
  },
  2: {
    level: 2,
    title: 'Build & Deliver Engineers',
    shortLabel: '2 - Build',
    filterLabel: '2 - Build',
    description:
      'Work done by our Build and Deliver Engineers. This work is being automated.',
    color: '#0369a1',
  },
  3: {
    level: 3,
    title: 'Engineering Technicians',
    shortLabel: '3 - Automated',
    filterLabel: '3 - Automated',
    description:
      'Work done by our Engineering Technicians. Automated work, with some trickiness remaining so it can’t be DIY or isn’t integrated into the PRENGUIN platform yet.',
    color: '#7c3aed',
  },
  4: {
    level: 4,
    title: 'Client DIY',
    shortLabel: '4 - DIY',
    filterLabel: '4 - DIY',
    description: 'Work done by clients, fully DIY.',
    color: '#059669',
  },
}

export function isWorkTypeLevel(value: unknown): value is WorkTypeLevel {
  return value === 1 || value === 2 || value === 3 || value === 4
}

/** Initial assignment rule: “Bespoke” in the name → 1, otherwise → 2. */
export function inferWorkTypeLevelFromName(name: string): WorkTypeLevel {
  return /\bbespoke\b/i.test(name) ? 1 : 2
}

export function parseWorkTypeLevel(value: unknown, fallbackName?: string): WorkTypeLevel {
  if (isWorkTypeLevel(value)) return value
  if (typeof value === 'string' && isWorkTypeLevel(Number(value))) {
    return Number(value) as WorkTypeLevel
  }
  if (fallbackName) return inferWorkTypeLevelFromName(fallbackName)
  return 2
}
